<lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

<div *ngIf="pageModeFinished$ | async" mat-dialog-content>
    <h4>Application Initiated</h4>
    <p>The client has been invited to upload documents to HomeDashboard. View and manage outstanding documents on the client’s active loan page or loan pipeline.</p>
    <div class="Vert-15"></div>
    <div class="row">
        <div class="col-12" align="end">
            <button mat-button class="btn btn-primary float-end" (click)="onFinished()">Close </button>
        </div>
    </div>
</div>

<div *ngIf="pageModeTaskSets$ | async" mat-dialog-content>
    <h4>Task Sets</h4>
    <p>View the list of documents and tasks affiliated with each set</p>

    <div>
        <ng-container *ngIf="lgvLoanAppSvc.taskSets$ | async as taskSets">
            <mat-form-field appearance="outline" floatLabel="always" class="col-12" title="Select a task set">
                <mat-label>Task Set</mat-label>
                <mat-select placeholder="Select a Task Set" [(ngModel)]="selectedInfoTaskSet">
                    <mat-option *ngFor="let item of taskSets" [value]="item">
                        {{item.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>

        <div *ngIf="selectedInfoTaskSet">
            <ul *ngFor="let t of selectedInfoTaskSet.taskItems">
                <li>{{t.name}}</li>
            </ul>
        </div>

    </div>

    <div class="Vert-15"></div>
    <div class="row">
        <div class="col-12" align="end">
            <button mat-button class="btn btn-primary float-end" (click)="onReturnToLoanApp()">Back to Loan Application</button>
        </div>
    </div>
</div>

<div *ngIf="pageModeLoanApp$ | async" mat-dialog-content>
    <div class="container">

        <!--<div class="alert alert-warning">
            <div class="row">
                <div class="col-3">state</div><div class="col-9">{{stateField.value}}</div>
                <div class="col-3">property</div><div class="col-9">{{propertyField.value}}</div>
                <div class="col-3">loan</div><div class="col-9">{{loanField.value}}</div>
                <div class="col-3">assistant</div><div class="col-9">{{assistantField.value}}</div>
                <div class="col-3">processor</div><div class="col-9">{{processorField.value}}</div>
            </div>
        </div>-->

        <div class="row">
            <div class="col-12">
                <h3 *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)" >Start Pre-Approval</h3>
                <h3 *ngIf="!(lgvUserSvc.IsPreLicensedAgent$ | async)">Start Application</h3>
                <div class="Vert-20"></div>
            </div>
        </div>

        <form [formGroup]="_form" [disabled]="isLoading$ | async">
            <div class="row">
                <div class="col-12 dialog-section">
                    {{ data?.isClientMode ? 'Client' : 'Client Information'}}
                </div>
                <div class="col-12 displayValue" *ngIf="data?.isClientMode && (clientInfo$ | async) as client">
                    {{client.firstName}} {{client.lastName}}
                </div>
                <ng-container *ngIf="!data?.isClientMode">
                    <div class="col-12"
                        *ngIf="(lgvUserSvc.IsAdmin$ | async) || (lgvUserSvc.IsCompanyAdmin$ | async) || ((lgvUserSvc.IsAgent$ | async) && !((lgvUserSvc.IsDLR$ | async) || (lgvUserSvc.IsPreLicensedAgent$ | async)))">
                        <lus-agent-search [SelectedCompany]="selectedCompany" [SelectedOrganization]="SelectedOrganization"
                            label="Agent"
                            [ShowLabelFloating]="true"
                            (OnAgentSelected)="selectAgent($event)"></lus-agent-search>
                    </div>
                    <div class="col-12 displayValue" *ngIf="!!agentDTO">
                        <lus-client-search label="Client"
                            [SelectedAgent]="currentAgent" 
                            [SelectedCompany]="currentCompany"
                            [SelectedOrganization]="currentOrganization"
                            [disabled]="!agentDTO || !agentDTO.agentInfo"
                            (OnClientDTOSelected)="selectClient($event)">
                        </lus-client-search>
                    </div>
                    <ng-container>
                        <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                            <mat-label>Borrower First Name</mat-label>
                            <input type="text" matInput formControlName="borrowerFirstName">
                        </mat-form-field>
                    </ng-container>
                    <ng-container >
                        <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                            <mat-label>Borrower Last Name</mat-label>
                            <input type="text" matInput formControlName="borrowerLastName">
                        </mat-form-field>
                    </ng-container>
                    <ng-container >
                        <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                            <mat-label>Borrower Email</mat-label>
                            <input type="text" matInput formControlName="borrowerEmail">
                        </mat-form-field>
                    </ng-container>
                    <ng-container >
                        <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                            <mat-label>Borrower Phone</mat-label>
                        <input type="text" matInput matInputPhoneNumber formControlName="borrowerPhone" >
                        </mat-form-field>
                    </ng-container>
                </ng-container>
                
                <div class="col-12 Vert-15"></div>

                <div *ngIf="!data?.isClientMode" class="col-12 dialog-section">Loan Information</div>

                <ng-container *ngIf="loans$ | async as loans">
                    <ng-container *ngIf="loans.length > 0">

                        <mat-form-field appearance="outline" floatLabel="always" class="col-12" title="Select a loan to refinance">
                            <mat-label>Loan</mat-label>
                            <mat-select formControlName="loanId" (selectionChange)="onLoanSelected($event.value)" placeholder="Select a Loan">
                                <mat-option *ngFor="let item of loans" [value]="item.loanInfo.id">
                                    ${{item.loanAnalysis.estimatedBalance | number : '1.0-0'}} |
                                    {{item.loanInfo.interestRate | number : '1.3-3'}}% Rate |
                                    {{item.loanType.name }} {{item.loanAnalysis.progType }} |
                                    1st |
                                    {{lgvDataHlpr.loanTermYears(item.loanInfo.loanTerm) | number : '1.0-2'}} Year Term
                                </mat-option>
                                <mat-option [value]="'TBD'">Other Loan</mat-option>
                            </mat-select>
                        </mat-form-field>

                    </ng-container>
                </ng-container>

                <ng-container *ngIf="!(selectedProperty$ | async)">
                    <lgv-state-dropdown 
                        [control]="_form.controls.state" 
                        [required]="true"
                        label="State"
                        [userId]="(currentAgentId$| async)||(selectedAgentId$ | async) || (currentUserId$ | async)"
                        (noLicensedStates)="onNoLicensedStates($event)">
                    </lgv-state-dropdown>
                </ng-container>

                <div class="Vert-15"
                    *ngIf="_form.controls.state.touched && (_form.controls.state.errors?.minlength 
                        || _form.controls.state.errors?.invalidStateCode 
                        || _form.controls.state.errors?.unlicensedState
                        || _form.controls.state.errors?.noLicensedStates)">
                </div>
                
                <div class="alert alert-warning" *ngIf="_form.controls.state.errors?.noLicensedStates">
                    <ng-container *ngIf="agentDTO && agentDTO.agentInfo">
                        {{agentDTO.agentInfo.firstName}} {{agentDTO.agentInfo.lastName}} has no active licenses. Please select a different user or contact support.
                    </ng-container>
                    <ng-container *ngIf="!(agentDTO && agentDTO.agentInfo)">
                        This user has no active licenses. Please select a different user or contact support.
                    </ng-container>
                </div>

                <mat-form-field appearance="outline" floatLabel="always" class="col-12" title="Loan Purpose">
                    <mat-label>Loan Purpose</mat-label>
                    <mat-select formControlName="loanPurpose" placeholder="Loan Purpose" *ngIf="LoanPurposeList">
                        <mat-option *ngFor="let item of LoanPurposeList" [value]="item.ID">
                            {{item.Display}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="col-12 dialog-section" *ngIf="!(lgvUserSvc.IsPreLicensedAgent$ | async)">
                    <span class="dialog-section">Document Request </span>  <a class="infoPopup" (click)="onOpenTaskSets()">
                        <fa-icon icon="info-circle"></fa-icon>
                    </a>
                </div>

                <div *ngIf="!(lgvUserSvc.IsPreLicensedAgent$ | async)">
                    <ng-container *ngIf="lgvLoanAppSvc.taskSets$ | async as taskSets">
                        <mat-form-field appearance="outline" floatLabel="always" class="col-12" title="Select a task set">
                            <mat-label>Task Set</mat-label>
                            <mat-select formControlName="taskSetId" placeholder="Select a Task Set">
                                <mat-option *ngFor="let item of taskSets" [value]="item.id">
                                    {{item.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-container>          

                    <ng-container *ngIf="taskList$ | async as taskList">
                        <ng-container *ngFor="let t of taskList">
                            <div class="col-11" >
                                <div><b>{{t.name}}</b></div>
                                <div>{{t.description}}</div>
                            </div>
                            <div class="col-1" style="text-align:right;">
                                <a (click)="onRemoveTask(t)"><fa-icon icon="trash" title="Remove Task"></fa-icon></a>
                            </div>
                        </ng-container>
                    </ng-container>
                


                <div class="col-12">
                    <div class="Vert-10"></div>
                    <a (click)="openTaskModal()"><fa-icon icon="plus" title="Add Task"></fa-icon>Add Task</a>
                </div>
            </div>

            </div>
        </form>

        <div class="row">
            <div class="col-12" align="end">
                <button mat-button class="btn btn-primary float-end"
                    (click)="onSubmit()"
                    [disabled]="!_form.valid || (isLoading$ | async)" style="margin-left:10px; margin-top: 15px;">
                        {{ (lgvUserSvc.IsPreLicensedAgent$ | async) ? 'Start Pre-Approval' : 'Start Loan Application' }}
                    </button>
                <button mat-stroked-button (click)="onCancel()" style="margin-top: 15px;" class="btn btn-secondary float-end"> Cancel </button>
            </div>
        </div>

    </div>
    <div class="Vert-15"></div>

    <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>


</div>
